var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 164.139,
    height: 59.607,
    viewBox: "0 0 164.139 59.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#3bbbbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#349b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#227474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#288e8e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(1.188 1.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tipografia",
    transform: "translate(39.709 11.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_124",
    "data-name": "Caminho 124",
    d: "M101.282,46.615a8.937,8.937,0,0,1-3.459,7.039,14.738,14.738,0,0,1-7.383,3.3,2.211,2.211,0,0,1-.261,0c-.312,0-1-.931-2.062-2.844a12.457,12.457,0,0,1-1.6-3.468c0-.149.1-.242.3-.284a21.022,21.022,0,0,0,3.882-1.131,3.3,3.3,0,0,0,2.09-3.091A4.735,4.735,0,0,0,91.4,43.2q-2.328-2.751-2.556-3.054a8.221,8.221,0,0,1-1.4-4.655,7.323,7.323,0,0,1,3.417-6.149,15.362,15.362,0,0,1,6.852-2.63h.344c.2,0,.368.163.489.466a58.489,58.489,0,0,0,2.444,5.339.466.466,0,0,1,.061.2c0,.228-.121.344-.363.344a4.656,4.656,0,0,1-.545-.061,3.868,3.868,0,0,0-.587-.061,4.781,4.781,0,0,0-2.551.666A2.374,2.374,0,0,0,95.7,35.75a5.3,5.3,0,0,0,1.457,3.035q2.57,3.235,2.691,3.4a8.151,8.151,0,0,1,1.438,4.432Z",
    transform: "translate(-86.52 -26.71)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_125",
    "data-name": "Caminho 125",
    d: "M139.188,41.186q0,2.5.126,7.5t.121,7.5c0,.279-.061.466-.182.526a4.231,4.231,0,0,1-.526.084,29.08,29.08,0,0,1-3.519.172,24.556,24.556,0,0,1-3.761-.172.633.633,0,0,1-.587-.652q0,.335.182-3.724.349-8.547.349-11.233,0-2.262-.144-6.783t-.14-6.783a.414.414,0,0,1,.466-.466c.419,0,1.047.023,1.89.065s1.476.065,1.89.065,1.038-.023,1.862-.065,1.434-.065,1.862-.065.587.158.587.466q0,2.262-.233,6.783T139.188,41.186Z",
    transform: "translate(-110.219 -26.946)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_126",
    "data-name": "Caminho 126",
    d: "M185.139,42.076a14.821,14.821,0,0,1-4.022,10.577,14.567,14.567,0,0,1-20.762-.037,14.752,14.752,0,0,1-4.045-10.539A14.83,14.83,0,0,1,160.355,31.5a14.431,14.431,0,0,1,20.729,0A14.9,14.9,0,0,1,185.139,42.076Zm-7.662-.037a7.593,7.593,0,0,0-1.862-5.158,6.378,6.378,0,0,0-9.748.079,8.039,8.039,0,0,0-.121,10.279,6.517,6.517,0,0,0,9.808-.121A7.5,7.5,0,0,0,177.477,42.039Z",
    transform: "translate(-123.822 -26.924)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_127",
    "data-name": "Caminho 127",
    d: "M253.549,42.076a14.821,14.821,0,0,1-4.022,10.577,14.578,14.578,0,0,1-20.771-.037,14.752,14.752,0,0,1-4.045-10.539A14.83,14.83,0,0,1,228.755,31.5a14.431,14.431,0,0,1,20.729,0A14.9,14.9,0,0,1,253.549,42.076Zm-7.662-.037a7.592,7.592,0,0,0-1.862-5.158,6.373,6.373,0,0,0-9.743.079,8.025,8.025,0,0,0-.126,10.274,6.289,6.289,0,0,0,4.976,2.169,6.219,6.219,0,0,0,4.851-2.286A7.481,7.481,0,0,0,245.886,42.039Z",
    transform: "translate(-160.38 -26.924)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_128",
    "data-name": "Caminho 128",
    d: "M320.212,28.262q0,2.4-.191,7.211t-.191,7.234V56.584c0,.382-.2.568-.587.568s-.815,0-1.466.042-1.145.047-1.466.047-.88-.033-1.578-.088-1.229-.084-1.578-.084c-.242,0-.535-.228-.871-.694q-1.452-2.039-6.55-9.054-1.4-1.964-4.25-5.768a.782.782,0,0,0-.3-.256.605.605,0,0,0-.163.466q0,2.444.135,7.327t.13,7.351c0,.493-.182.736-.545.736h-6.983c-.391,0-.587-.214-.587-.652q0-2.267.214-6.862t.214-6.89q0-2.416-.2-7.243c-.126-3.212-.191-5.623-.191-7.22,0-.312.265-.466.791-.466.777,0,1.746-.056,2.891-.168.27-.028.8-.121,1.6-.275a9.31,9.31,0,0,1,1.6-.191c.163,0,.414.242.749.717l7.541,10.763q1.006,1.429,3.035,4.25c.34.433.628.652.871.652s.265-.549.265-1.643q0-2.216-.233-6.657t-.233-6.671c0-.521.14-.782.424-.782q1.215,0,3.659-.1c1.634-.074,2.854-.107,3.664-.107C320.091,27.61,320.212,27.829,320.212,28.262Z",
    transform: "translate(-196.971 -26.977)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "simbolo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_129",
    "data-name": "Caminho 129",
    d: "M29.627,86.934,10.192,98.818A11.391,11.391,0,0,1,8.418,93.5a11.792,11.792,0,0,1,2.127-7.448,11.429,11.429,0,0,1,2.481-2.467,104.105,104.105,0,0,1,9.1-6.457,11.279,11.279,0,0,1,2.947,1.494,11.112,11.112,0,0,1,3.9,4.962,10.474,10.474,0,0,1,.661,3.347Z",
    transform: "translate(-5.057 -41.965)",
    fill: "none",
    stroke: "#3dc9c8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.33
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2113",
    "data-name": "Caminho 2113",
    d: "M13.79,13.456C20.251,9.513,26.736,5.5,33.193,1.59A11.391,11.391,0,0,1,34.966,6.9a11.773,11.773,0,0,1-2.127,7.448,12.145,12.145,0,0,1-2.477,2.481A63.062,63.062,0,0,1,21.829,23.3a8.6,8.6,0,0,1-3.259-1.327,11.582,11.582,0,0,1-4.031-5.121,9.673,9.673,0,0,1-.749-3.394Z",
    transform: "translate(-7.938 -1.59)",
    fill: "none",
    stroke: "#1d6fbb",
    strokeWidth: 2.33
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_130",
    "data-name": "Caminho 130",
    d: "M31.375,52.1a12.788,12.788,0,0,1-2.328,5.046,13.337,13.337,0,0,1-3.31,3.1,10.474,10.474,0,0,0-1.964-5.861,10.707,10.707,0,0,0-5-3.836,9.641,9.641,0,0,0-2.444-.605,14.575,14.575,0,0,0-2.588-.061A9.8,9.8,0,0,1,9.8,49.3a12.215,12.215,0,0,1-2.989-1.4A13.449,13.449,0,0,1,1.689,41.12a12.383,12.383,0,0,1,.582-8.379,12.844,12.844,0,0,1,4.8-5.661,11.61,11.61,0,0,0,2.481,6.373,9.143,9.143,0,0,0,1.774,1.774,9.608,9.608,0,0,0,2.83,1.4,14.277,14.277,0,0,0,3.9.712,26.4,26.4,0,0,1,4.255.354,15.648,15.648,0,0,1,4.576,2.328,12.727,12.727,0,0,1,4.19,6.224A12.29,12.29,0,0,1,31.375,52.1Z",
    transform: "translate(-1.218 -15.214)",
    fill: "none",
    stroke: "#2e9696",
    strokeWidth: 2.33
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/LogoDark.e463a7723b66ff2db6f551705f1472e6.svg";
export { ForwardRef as ReactComponent };